import { FC, useState } from 'react';
import VerticalCarousel from './VerticalCarousel';
import { config } from '@react-spring/web';
import Cards from '../Cards';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const slides = [
  {
    key: 1,
    content: <Cards type="chess" />,
  },
  {
    key: 2,
    content: <Cards type="roboArm" />,
  },
  {
    key: 3,
    content: <Cards type="chart" />,
  },
  ...(!ApplicationDomainUtility.isB2b
    ? [
        {
          key: 4,
          content: <Cards type="puzzle" />,
        },
      ]
    : []),
];

const initialState = {
  goToSlide: 1,
  offsetRadius: 3,
  config: config.gentle,
};

const StrategyTool: FC = () => {
  const [state] = useState(initialState);
  const { offsetRadius, config } = state;

  return (
    <section className="strategy-carousel-container">
      <VerticalCarousel slides={slides} offsetRadius={offsetRadius} animationConfig={config} />
    </section>
  );
};
export default StrategyTool;
